import type {
  CreateReviewAccountBody,
  RemoveReviewAccountResult,
  ReviewAccountItem,
  ReviewAccountsResponse,
  UpdateReviewAccountBody,
  UpdateReviewAccountResult,
} from '@sparkapp/shared-types';
import { apiRequest } from './apiClient';

type Envelope<T> = { success: true; data: T };
const BASE = '/v2/admin/review-accounts';

export const reviewAccountsApi = {
  async list(): Promise<ReviewAccountsResponse> {
    return (await apiRequest<Envelope<ReviewAccountsResponse>>(BASE)).data;
  },

  async create(body: CreateReviewAccountBody): Promise<ReviewAccountItem> {
    return (await apiRequest<Envelope<ReviewAccountItem>>(BASE, { method: 'POST', body })).data;
  },

  async update(userId: number, body: UpdateReviewAccountBody): Promise<UpdateReviewAccountResult> {
    return (
      await apiRequest<Envelope<UpdateReviewAccountResult>>(`${BASE}/${userId}`, { method: 'PATCH', body })
    ).data;
  },

  async remove(userId: number): Promise<RemoveReviewAccountResult> {
    return (await apiRequest<Envelope<RemoveReviewAccountResult>>(`${BASE}/${userId}`, { method: 'DELETE' })).data;
  },
};
